app.controller('CheckoutAddressController', [
                                            '$scope',
                                            'Config',
                                            'CacheFactory',
                                            'quote',
                                            '$window',
                                            'cart',
                                            'helper',
                                            '$timeout',
function($scope,Config,CacheFactory,quote,$window,cart,helper,$timeout){
  $scope.base_url = Config.base_url;
  $scope.countries = [];
  $scope.parkingRestrictions = ['None','Single Yellow','Double Yellow','Bus Lane','Own Loading Bay','Street Loading Bay'];
  $scope.savedAddresses = [];
  $scope.addressChangeWatch = true;
  $scope.craftyResults = {
      billing:{
        foundAddresses:[],
        selectedAddress:'',
        error:null
      },
      delivery:{
        foundAddresses:[],
        selectedAddress:'',
        error:null
      },collection:{
        foundAddresses:[],
        selectedAddress:'',
        error:null
      }
  };

  $scope.steps = {
      'billing':{
        'active':true,
        'filled':false,
      },
      'delivery':{
        'active':false,
        'filled':false,
      },
      'collection':{
        'active':false,
        'filled':false,
      }
  };

  $scope.selectedSavedAddress = {
    billing:null,
    delivery:null,
    collection:null
  }
  
  $scope.addresses = {
                billing:{
                  Lift:'',
                  LiftFit:'',
                  Floor:'',
                  County:'',
                  ParkingRestrictions:'None',
                  AdditionalInfo:'',
                  Country:'GB'
                },delivery:{
                  Lift:'',
                  LiftFit:'',
                  Floor:'',
                  County:'',
                  ParkingRestrictions:'None',
                  AdditionalInfo:'',
                  Country:'GB'
                },collection:{
                  Lift:'',
                  LiftFit:'',
                  Floor:'',
                  County:'',
                  ParkingRestrictions:'None',
                  AdditionalInfo:'',
                  Country:'GB'
                }
            };

  $scope.init = function(){
    //get country list
    quote.getCountryList().then(function(response) {
          $scope.countries = response.data;
    }, function(response) {
      console.log(response);
    });

    //if user is logged in get all saved addresses
    if($('#loggedin').val()==1){
      customerID = $('#customerID').val();
      quote.getSavedAddresses(customerID).then(function(response) {
          $scope.savedAddresses = response.data;
        }, function(response) {
          console.log(response);
        });
    }

    //check if the quote cache exist otherwise redirect to details page
    if(!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('cart'))){
      $window.location.href = $scope.base_url+'checkout/details';
    }else{
      $scope.quote = CacheFactory.get('appCache').get('quote'); 
      $scope.addresses.delivery.PostCode = $scope.quote.deliveryPostcode;
      $scope.addresses.collection.PostCode = $scope.quote.collectionPostcode;

      if(angular.isDefined(CacheFactory.get('appCache').get('address'))){
          $scope.selectedSavedAddress = CacheFactory.get('appCache').get('address').selectedSavedAddress;
          $scope.addresses = CacheFactory.get('appCache').get('address').addresses;
          $scope.steps = CacheFactory.get('appCache').get('address').steps;
      }else{
          $scope.addresses.billing.ContactName = $scope.quote.name;
          $scope.addresses.billing.Telephone = $scope.quote.telephone;
          $scope.addresses.billing.PostCode = $scope.quote.deliveryPostcode;
          $scope.addresses.billing.CompanyName = $scope.quote.company;
      }

      $scope.$watch('addresses.billing', function(newVal, oldVal){
        if(newVal!==oldVal && $scope.addressChangeWatch){
          $scope.selectedSavedAddress.billing = null;
        }
      }, true);
      $scope.$watch('addresses.delivery', function(newVal, oldVal){
        if(newVal!==oldVal && $scope.addressChangeWatch){
          $scope.selectedSavedAddress.delivery = null;
        }
      }, true);
      $scope.$watch('addresses.collection', function(newVal, oldVal){
        if(newVal!==oldVal && $scope.addressChangeWatch){
          $scope.selectedSavedAddress.collection = null;
        }
      }, true);
    }
  }

  $scope.saveAddress = function(form,targetStep){
    if(form.$valid){
      helper.showLoader();
      var currentStep = $('form[name="'+form.$name+'"]').data('step');
      //set step to be filled
      $scope.steps[currentStep].filled = true;
      //trigger change step function
      $scope.changeStep(targetStep);
      //cache address and go to next step
      $scope.cacheAddressStep();
      helper.hideLoader();
    }
  }

  $scope.cacheAddressStep = function(){
      //cache address and go to next step
      var address = {
          selectedSavedAddress:$scope.selectedSavedAddress,
          addresses:$scope.addresses,
          steps:$scope.steps
      }
      CacheFactory.get('appCache').put('address',address);
  }

  $scope.changeStep = function(targetStep){
    if(targetStep){
      //disable all the steps and activate the target step
      $scope.steps.billing.active = false;
      $scope.steps.delivery.active = false;
      $scope.steps.collection.active = false;
      $scope.steps[targetStep].active = true;
      //cache address and go to next step
      $scope.cacheAddressStep();

      //if target step is delivery then check if there is something saved in cache
      //if not then if delivery postcode is the same as billing then pre-fill delivery with billing details
      if(targetStep=='delivery'){
        if(!CacheFactory.get('appCache').get('address').steps.delivery.filled){
          if($scope.addresses.billing.PostCode.replace(/ /g,'').toLowerCase()==$scope.addresses.delivery.PostCode.replace(/ /g,'').toLowerCase()){
              $scope.addresses.delivery = $scope.addresses.billing;
              if($scope.selectedSavedAddress.billing){
                $scope.selectedSavedAddress.delivery = $scope.selectedSavedAddress.billing;
              }
          }
        }
      }
      //the same for collection step
      if(targetStep=='collection'){
        if(!CacheFactory.get('appCache').get('address').steps.collection.filled){
          if($scope.addresses.delivery.PostCode.replace(/ /g,'').toLowerCase()==$scope.addresses.collection.PostCode.replace(/ /g,'').toLowerCase()){
              $scope.addresses.collection = $scope.addresses.delivery;
              if($scope.selectedSavedAddress.delivery){
                $scope.selectedSavedAddress.collection = $scope.selectedSavedAddress.delivery;
              }
          }
        }
      }
    }else{
      $window.location.href = $scope.base_url+'checkout/delivery';
    }
  }

  $scope.selectSavedAddress = function(type,selectedAddress){
    //turn off watchers for the address change so it's only triggered by typing not selecting a saved address
    $scope.addressChangeWatch = false;
    //select the ddress
    $scope.addresses[type] = selectedAddress;
    //turn on the address change watcher back
    $timeout(function(){
      $scope.addressChangeWatch = true;
    }, 10);
  }

  $scope.findAddress = function(type){
    helper.showLoader();
    $scope.craftyResults[type].error = null;
    $scope.craftyResults[type].foundAddresses = [];
    $scope.craftyResults[type].selectedAddress = '';

     quote.getCraftyResults($scope.addresses[type].PostCode).then(function(response) {
        if(response.data.results.length){
          var addresses = response.data.results;
          //loop through addresses
          angular.forEach(addresses, function(address, key) {
              //and add all labels with id's
              $scope.craftyResults[type].foundAddresses.push({id:address.id,address:address.labels.join(' | ')});
          });
        }else{
          $scope.craftyResults[type].error = 'No Matching Address found!';
        }
        helper.hideLoader();
    }, function(response) {
        $scope.craftyResults[type].error = 'No Matching Address found!';
        helper.hideLoader();
    });
  }

  $scope.clearFoundAddresses = function(type){
    $scope.craftyResults[type].foundAddresses = [];
  }

  $scope.selectFoundAddress = function(type){
    helper.showLoader();
    //query API to get address
    quote.selectCraftyAddress($scope.craftyResults[type].selectedAddress).then(function(response) {
          //then fill address form
          $scope.addresses[type].address1 = response.data.result.line_1;
          $scope.addresses[type].address2 = response.data.result.line_2;
          $scope.addresses[type].town = response.data.result.locality;
          $scope.addresses[type].county = response.data.result.province_name;
          $scope.addresses[type].country = 'GB';
          $scope.addresses[type].postCode = response.data.result.postal_code;
          $scope.addresses[type].companyName = response.data.result.company_name;
          helper.hideLoader();
    }, function(response) {
        console.log(response);
        helper.hideLoader();
    });
  }

}]);

app.filter('postcodeFilter', function() {
  return function(addresses,postcode) {
      var filteredAddresses = [];
      //loop through and return addresses with matching postcodes
      angular.forEach(addresses, function(address, key) {
        if(address.PostCode.replace(/ /g,'').toLowerCase()==postcode.replace(/ /g,'').toLowerCase()){
                filteredAddresses.push(address);
        }
      });
      return filteredAddresses;
  };
});